<div class='form-progress'>
	<div class='container'>
		<div class='content'>
			<div class='progress'>
				<div class='inner-container'>
					<div class='inner-content'>
						<div class='progress-header'>
							<div class='title' i18n>Your Quote Request</div>
							<div class='percentage' i18n>{{formService.progress}}% <span>progress</span></div>
						</div>
						<div class='bar'>
							<div [style.width.%]='formService.progress' class='point-of-progress'></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>